import React from 'react';

import { green, orange, red } from 'data/colors';
import { money as moneyFormatter } from 'utils/format/money';
import renewalMethodStatuses from 'data/renewal_method_statuses';
import statuses from 'data/policy_plan_statuses';
import CellStringItemWithTooltip from 'components/ui/Table/CellStringItemWithTooltip';
import Actions from './Actions';

const statusName = (value) => {
  const status = statuses.find((item) => item.value == value);
  return status == null ? '' : status.label;
};

const sessionsTitle = (sessions) => (sessions == '0' ? 'TA' : sessions);

const renewalMethodStatusName = (value) => {
  const status = renewalMethodStatuses.find((item) => item.value == value);

  return status === null ? '' : status.label;
};

const columns = (startEdit) => [
  {
    name: 'Plan Name',
    selector: 'attributes.name',
    sortable: true,
    width: '160px',
    cell: (row) => <CellStringItemWithTooltip text={row.attributes.name} />,
  },
  {
    name: 'Sessions',
    selector: 'attributes.sessions',
    width: '70px',
    sortable: true,
    cell: (row) => sessionsTitle(row.attributes.sessions),
    sortFunction: (rowA, rowB) => {
      const a = rowA.attributes.sessions == 0 ? 1000 : rowA.attributes.sessions;
      const b = rowB.attributes.sessions == 0 ? 1000 : rowB.attributes.sessions;

      if (a > b) {
        return 1;
      }

      if (b > a) {
        return -1;
      }

      return 0;
    },
  },
  {
    name: 'Effective Date',
    selector: 'attributes.effective_date_formatted',
    width: '110px',
    sortable: true,
    sortFunction: (a, b) => a.attributes.effective_date_int - b.attributes.effective_date_int,
  },
  {
    name: 'Renewal Date',
    selector: 'attributes.renewal_date_formatted',
    width: '110px',
    sortable: true,
    sortFunction: (a, b) => a.attributes.renewal_date_int - b.attributes.renewal_date_int,
  },
  {
    name: 'Renewal Method',
    selector: 'attributes.renewal_method',
    cell: (row) => renewalMethodStatusName(row.attributes.renewal_method),
    sortable: true,
    conditionalCellStyles: [
      {
        when: (row) => row.attributes.renewal_method === 'automatic',
        style: {
          color: green,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'adjusted',
        style: {
          color: orange,
        },
      },
      {
        when: (row) => row.attributes.renewal_method === 'terminated',
        style: {
          color: red,
        },
      },
    ],
  },
  {
    name: 'Status',
    selector: 'attributes.status',
    sortable: true,
    width: '100px',
    cell: (row) => statusName(row.attributes.status),
  },
  {
    name: 'EEs',
    selector: 'attributes.employees_covered',
    width: '90px',
    sortable: true,
    cell: (row) => row.attributes.employees_covered_title,
  },
  {
    name: 'One-Time',
    selector: (row) => row.attributes.onetime_total,
    width: '110px',
    sortable: true,
    cell: (row) => moneyFormatter(row.attributes.onetime_total, row.attributes.currency.title),
  },
  {
    name: 'Billing',
    selector: 'attributes.billing',
    width: '90px',
    sortable: true,
  },
  {
    name: 'Premium',
    selector: (row) => (row.attributes.payment_mode == 'monthly'
      ? row.attributes.monthly_total
      : row.attributes.annual_total),
    width: '110px',
    sortable: true,
    cell: (row) => moneyFormatter(
      row.attributes.payment_mode == 'monthly'
        ? row.attributes.monthly_total
        : row.attributes.annual_total,
      row.attributes.currency.title,
    ),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '140px',
    right: true,
    cell: (row) => <Actions row={row} startEdit={startEdit} />,
  },
];

export default columns;
